import { OrderLineItemDto } from '../../../dtos';

export const getOrderLineItemTooltipData = (orderLineItem: OrderLineItemDto) => {
    const convertMinsToHrsMins = (mins: number) => {
        let h = Math.floor(mins / 60);
        let m = mins % 60;
        let hours = h < 10 ? '0' + h : h;
        let minutes = m < 10 ? '0' + m : m;
        return `${hours}:${minutes}`;
    };

    let intervalTime = '';
    if (orderLineItem?.dispatchingIntervalTime) {
        intervalTime = convertMinsToHrsMins(orderLineItem.dispatchingIntervalTime!);
    }

    const getHaulToAddressForOrderLineItem = (orderLineItem: OrderLineItemDto) => {
        let address = '';

        const addressParts = [
            orderLineItem.haulToSiteName,
            orderLineItem.haulToRegion?.name,
            orderLineItem.haulToAddressLine1,
            orderLineItem.haulToAddressLine2,
        ];

        address += addressParts.filter((part) => part && part.trim() !== '').join('<br> ');

        if (orderLineItem.haulToCity && orderLineItem.haulToCity.trim() !== '') {
            address += `<br> ${orderLineItem.haulToCity}`;
            if (orderLineItem.haulToState && orderLineItem.haulToState.trim() !== '') {
                address += `,`;
            }
        }
        if (orderLineItem.haulToState && orderLineItem.haulToState.trim() !== '') {
            if (!orderLineItem.haulToCity || orderLineItem.haulToCity.trim() === '') {
                address += `<br>`;
            }
            address += ` ${orderLineItem.haulToState}`;
        }
        if (orderLineItem.haulToZipCode && orderLineItem.haulToZipCode.trim() !== '') {
            address += ` ${orderLineItem.haulToZipCode}`;
        }

        if (address.startsWith('<br>')) {
            address = address.substring(4);
        }

        return address;
    };

    const getHaulFromAddressForOrderLineItem = (orderLineItem: OrderLineItemDto) => {
        let address = '';

        const addressParts = [
            orderLineItem.haulFromSiteName,
            orderLineItem.haulFromRegion?.name,
            orderLineItem.haulFromAddressLine1,
            orderLineItem.haulFromAddressLine2,
        ];

        address += addressParts.filter((part) => part && part.trim() !== '').join('<br> ');

        if (orderLineItem.haulFromCity && orderLineItem.haulFromCity.trim() !== '') {
            address += `<br> ${orderLineItem.haulFromCity}`;
            if (orderLineItem.haulFromState && orderLineItem.haulFromState.trim() !== '') {
                address += `,`;
            }
        }
        if (orderLineItem.haulFromState && orderLineItem.haulFromState.trim() !== '') {
            if (!orderLineItem.haulFromCity || orderLineItem.haulFromCity.trim() === '') {
                address += `<br>`;
            }
            address += ` ${orderLineItem.haulFromState}`;
        }
        if (orderLineItem.haulFromZipCode && orderLineItem.haulFromZipCode.trim() !== '') {
            address += ` ${orderLineItem.haulFromZipCode}`;
        }

        if (address.startsWith('<br>')) {
            address = address.substring(4);
        }

        return address;
    };

    const getMemos = (orderLineItem: OrderLineItemDto) => {
        const memoHtml = `<div class="memo-container">
                                <div class="memo-body">
                                    <div class="memo-row">
                                        <span class="memo-label">Dispatch/Billing Memo:</span>
                                        <span class="memo-value">${orderLineItem?.dispatchBillingMemo ?? ''}</span>
                                    </div>
                                    <div class="divider"></div>
                                    <div class="memo-row">
                                        <span class="memo-label">Driver Memo:</span>
                                        <span class="memo-value">${orderLineItem?.driverMemo ?? ''}</span>
                                    </div>
                                </div>
                            </div>`;
        return memoHtml;
    };

    const toolTipHtml = `<div class="html-container">
                            <div class="flex-box">
                                <div class="tooltip-container">
                                    <div class="tooltip-body">
                                        <div class="tooltip-row">
                                            <span class="tooltip-label">Customer:</span>
                                            <span class="tooltip-value">${orderLineItem?.customerName ?? ''}</span>
                                        </div>
                                        <div class="tooltip-row">
                                            <span class="tooltip-label">Orderer:</span>
                                            <span class="tooltip-value">${orderLineItem?.orderer ?? ''}</span>
                                        </div>
                                        <div class="tooltip-row">
                                            <span class="tooltip-label">Project Name:</span>
                                            <span class="tooltip-value">${orderLineItem?.projectName ?? ''}</span>
                                        </div>
                                        <div class="tooltip-row">
                                            <span class="tooltip-label">Job Name:</span>
                                            <span class="tooltip-value">${orderLineItem?.jobName ?? ''}</span>
                                        </div>
                                        <div class="tooltip-row">
                                            <span class="tooltip-label">PO Number:</span>
                                            <span class="tooltip-value">${orderLineItem?.poNumber ?? ''}</span>
                                        </div>
                                        <div class="tooltip-row">
                                            <span class="tooltip-label">Job Number:</span>
                                            <span class="tooltip-value">${orderLineItem?.customerJobNumber ?? ''}</span>
                                        </div>
                                        <div class="tooltip-row">
                                            <div class="tooltip-row">
                                                <span class="tooltip-label">Order #:</span>
                                                <span class="tooltip-value">${orderLineItem?.orderNumber ?? ''}</span>
                                            </div>
                                            <div class="tooltip-row">
                                                <span class="tooltip-label">Line Item #:</span>
                                                <span class="tooltip-value">${orderLineItem?.orderLineItemNumber}</span>
                                            </div>
                                        </div>
                                        <div class="divider"></div>
                                        <div class="tooltip-row">
                                            <span class="tooltip-label">Description:</span>
                                            <span class="tooltip-value">${orderLineItem?.name ?? ''}</span>
                                        </div>
                                        <div class="tooltip-row">
                                            <span class="tooltip-label">Requirements:</span>
                                            <span class="tooltip-value">${orderLineItem?.requirements ?? ''}</span>
                                        </div>
                                        <div class="tooltip-row">
                                            <span class="tooltip-label">Equipment Type:</span>
                                            <span class="tooltip-value">${orderLineItem?.equipmentTypeType ?? ''}</span>
                                        </div>
                                        <div class="divider"></div>
                                        <div class="tooltip-row">
                                            <div class="tooltip-row">
                                                <span class="tooltip-label">Yard Time:</span>
                                                <span class="tooltip-value">${orderLineItem?.yardTime ? new Date(orderLineItem?.yardTime).toLocaleTimeString() : 'ASAP '}</span>
                                            </div>
                                            <div class="tooltip-row">
                                                <span class="tooltip-label">Onsite Time:</span>
                                                <span class="tooltip-value">${orderLineItem?.onsiteTime ? new Date(orderLineItem?.onsiteTime).toLocaleTimeString() : 'ASAP '}</span>
                                            </div>
                                        </div>
                                        <div class="tooltip-row">
                                            <span class="tooltip-label">Interval Time:</span>
                                            <span class="tooltip-value">${intervalTime}</span>
                                        </div>
                                        <div class="divider"></div>
                                        <div class="tooltip-row">
                                            <span class="tooltip-label">Site:</span>
                                            <span class="tooltip-value">${orderLineItem?.siteName ?? ''}</span>
                                        </div>
                                        <div class="tooltip-row">
                                            <span class="tooltip-label">Haul To:</span>
                                            <span class="tooltip-value">${getHaulToAddressForOrderLineItem(orderLineItem)}</span>
                                        </div>
                                        <div class="tooltip-row">
                                            <span class="tooltip-label">Haul From:</span>
                                            <span class="tooltip-value">${getHaulFromAddressForOrderLineItem(orderLineItem)}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="divider-vertical"></div>
                            <div class="flex-box">
                                ${getMemos(orderLineItem)}
                            </div>
                        </div>`;

    return toolTipHtml;
};
